import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ActividadesService } from './api/actividades.service';
import { AdjuntosService } from './api/adjuntos.service';
import { CheckService } from './api/check.service';
import { EmpresasService } from './api/empresas.service';
import { EventosService } from './api/eventos.service';
import { FotosActividadesService } from './api/fotosActividades.service';
import { FotosEventosService } from './api/fotosEventos.service';
import { KoguiService } from './api/kogui.service';
import { KoguiActividadesService } from './api/koguiActividades.service';
import { KoguiEmpresasService } from './api/koguiEmpresas.service';
import { KoguiEventosService } from './api/koguiEventos.service';
import { KoguiFavoriteService } from './api/koguiFavorite.service';
import { KoguiOpinionesService } from './api/koguiOpiniones.service';
import { KoguiProgramacionActividadService } from './api/koguiProgramacionActividad.service';
import { KoguiReservasService } from './api/koguiReservas.service';
import { ProgramacionActividadService } from './api/programacionActividad.service';
import { ReservasService } from './api/reservas.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ActividadesService,
    AdjuntosService,
    CheckService,
    EmpresasService,
    EventosService,
    FotosActividadesService,
    FotosEventosService,
    KoguiService,
    KoguiActividadesService,
    KoguiEmpresasService,
    KoguiEventosService,
    KoguiFavoriteService,
    KoguiOpinionesService,
    KoguiProgramacionActividadService,
    KoguiReservasService,
    ProgramacionActividadService,
    ReservasService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
